import AsyncAssetCommentButton from 'asset-actions-lib/components/buttons/AsyncAssetCommentButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ACTION_IDS } from 'asset-actions-lib/constants/actionIds';
import { jsx as _jsx } from "react/jsx-runtime";
export const COMMENT_ACTION = {
  id: ACTION_IDS.COMMENT,
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "assetActionsLib.sharedActions.comment"
  }),
  onConfirm: () => {},
  actionGroup: 1,
  ActionButton: AsyncAssetCommentButton
};